import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const attributeRef = async (data) => {
    const code = localStorage.getItem("fa_ref") || document.cookie.match(/(?:^|; )fa_ref=([^;]+)/)?.[1];
    if (!code || !data || data.referred_by) return;
    try { const r = await api.post("/affiliates/attribute", { code }); if (["ok", "already", "expired", "invalid"].includes(r.data.status)) { localStorage.removeItem("fa_ref"); document.cookie = "fa_ref=; Max-Age=0; Path=/; SameSite=Lax; Secure"; } } catch { /* ignore */ }
  };
  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      attributeRef(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    attributeRef(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshUser: checkAuth }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
